import styles from './PartiesPage.module.css';

function PartiesPage() {
  return (
    <div className={styles.page}>
      <section className={styles.content}>
        <h1 className={styles.title}>Private Parties</h1>
        <article className={styles.description}>
          Make your next private event a memorable one. The Hub Pub's upstairs loft, with pool
          tables and ski-ball is available for private events. Our private event menu offers a
          variety of freshly prepared delicious appetizers all the way up to a full buffet with
          several entrees.
        </article>
        <h2 className={styles.contactHeading}>Request Info</h2>
        <p className={styles.contactText}>
          To inquire about booking a private event, please contact us:
        </p>
        <p className={styles.contactMethod}>
          <a href="mailto:hubpubboston@gmail.com">hubpubboston@gmail.com</a>
        </p>
        <p className={styles.contactMethod}>
          <a href="tel:617-227-8952">617-227-8952</a>
        </p>
      </section>
    </div>
  );
}

export default PartiesPage;
